import type { FaireProductEntity } from "../../entity_types/product";

export const p_ysb7mrxkbc: FaireProductEntity = {
  token: "p_ysb7mrxkbc",
  type: "product",
  name: "I ❤️ Meat Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/631f20bfd70020f5c0d8025f35c909d7f632ac2c94e6a1697769bf802407ab7b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3710e0c35cad51cf4a7949e20e1567f8a85ea5d4f421c2007beaee0af9776116.jpeg",
    "https://cdn.faire.com/fastly/92d3c3bd0dca0eced27f3efe4f5fa85542b37d13533b91a8c41c2124f1f0a1b1.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/8da523a2fc6ccedcf8d39fce96f218f63110409bbd07f06f331a0ed5b515759f.jpeg",
    "https://cdn.faire.com/fastly/a2fccc3607b050e290a5dedce89661b3e9c25269414225392a3bf88306f87d70.jpeg"
  ],
  priceDollars: 6.75,
  description: "For serious meat lovers who wear their cravings on their feet. These socks bring that SIZZLE—no grilling required. 🥩\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:26.862Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
